<tui-root>
	<app-page-wrapper *ngIf="ready$ | async; else loading">
		<router-outlet></router-outlet>
	</app-page-wrapper>
	<ng-container ngProjectAs="tuiOverContent">
	</ng-container>
	<ng-container ngProjectAs="tuiOverDialogs">
	</ng-container>
	<ng-container ngProjectAs="tuiOverAlerts">
	</ng-container>
	<ng-container ngProjectAs="tuiOverPortals">
	</ng-container>
	<ng-container ngProjectAs="tuiOverHints">
	</ng-container>
</tui-root>

<ng-template #loading>
	<div class="loading-wrapper">
		<div class="inner-wrapper">
			<div class="blinkable">Загрузка...</div>
		</div>
	</div>
</ng-template>